import React from 'react'

function Disclaimer({ text }: { text: string }) {
  return (
    <div className="bg-custom-blue">
      <div className="container mx-auto px-4 py-4 text-primary">
        <p className="text-base">{text}</p>
      </div>
    </div>
  )
}

export default Disclaimer
